import Base from "./base"

export default class RedirectIfAuthenticated extends Base {
  constructor(Vue, store) {
    super("redirect-if-authenticated", Vue, store)
  }

  async before(to, from, next) {
    console.log("redirect-if-authenticated")
    const slug = to.params.slug

    if (_.isNull(slug)) {
      next({name: "NotFound"})
      return
    }

    // local storageにトークンがあるか判定
    if (!this.store.getters["auth/token"]) {
      // local storageにトークンがない場合は対象ログイン画面へ遷移
      next()
      return
    }

    await this.store.dispatch("auth/selfByEvent", slug)

    // トークンが有効で空のユーザ情報を保持していないか確認
    if (Object.keys(this.store.getters["auth/user"]).length) {
      // socketのinit処理を実行し、イベントTOPへ遷移
      next({name: "Top", params: {slug: from.params.slug || to.params.slug}})
    } else {
      // 空のユーザ情報だった場合は対象ログイン画面へ遷移
      next()
    }
  }
}
